<script>
    export let icon = null;
    export let title = null;
    export let href = '#';
    export let extra = null;
    export let active = null;

    let domIcon;

    $: icon && domIcon && window.jQuery && window.jQuery(domIcon).addLiviconEvo();
</script>


<a href={href} class="list-group-item list-group-item-action {active?'active':''}" on:click|preventDefault >
    {#if icon}
        <div class="fonticon-wrap d-inline mr-25">
            <i bind:this={domIcon} class="livicon-evo" data-options={icon}></i>
        </div>
    {/if}

    {title || '-'}

    {#if extra}<span class="badge badge-light-danger badge-pill badge-round float-right mt-50">{extra}</span>{/if}
</a>
